import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Pengaman token kedaluwarsa: kalau server membalas 401 untuk request API user
// yang membawa token, token dibuang lalu halaman dimuat ulang sehingga user
// kembali ke layar login (bukan halaman kosong). Panel admin/subadmin dikecualikan
// karena memakai token & alur login sendiri.
(function pasangPenjagaToken401() {
  const path = window.location.pathname;
  if (path === '/admin' || path === '/subadmin') return;
  const fetchAsli = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await fetchAsli(...args);
    try {
      if (res.status === 401) {
        const input = args[0];
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const headers = (args[1] && args[1].headers) || {};
        const adaAuth = !!(headers.Authorization || headers.authorization);
        const apiUser = url.includes('/api/') && !url.includes('/api/admin') && !url.includes('/api/subadmin') && !url.includes('/api/login');
        if (adaAuth && apiUser && localStorage.getItem('token')) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.reload();
        }
      }
    } catch {}
    return res;
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
